<span>
	<!-- Empty because it loads a priority view -->
</span>